import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { blue, green, red } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import LandscapeIcon from '@material-ui/icons/Landscape';
import FlightLandIcon from '@material-ui/icons/FlightLand';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import {
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import { propTypes } from 'reactstrap/lib/TooltipPopoverWrapper';
import { FlightLand } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: blue[500],
  },
  avatarin: {
    backgroundColor: green[500],
  },
  avatarout: {
    backgroundColor: red[500],
  },
  
  title : {
    color: 'white',
    fontSize:'18px'
  }

}));

const CardServicos = props => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  
  //const[classavatarinout, setClassAvatarInOut] = React.useState();

  const { ...rest } = props;
  
  console.log(JSON.stringify(rest.servicos, null, 2));
  
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };


  /* get avatar */
  function getAvatar(tiposervico){
    if (tiposervico === 0) {
//      setClassAvatarInOut(classes.avatarin)
      return <LandscapeIcon />
    }   
    else{
      //setClassAvatarInOut(classes.avatarin)
      return <AirportShuttleIcon />
    }
  }

  function getClassNameAvatar(tiposervico){
    if (tiposervico === 1) {
      return classes.avatarin
    }   
    else
    if (tiposervico === 2) {
       return classes.avatarout
    }
  }

  function getAvatarChegadaPartida(tiposervico){
    if (tiposervico === 1) {

      return <FlightLandIcon />
    }   
    else{
    return <FlightTakeoffIcon />
    }

  }
  
  return (
    <Card className={classes.root}>

      <CardHeader
        titleTypographyProps={{ className: classes.title }}
        className={classes.avatar}

      avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            <LocalActivityIcon />
          </Avatar>
        }
        title={"SERVIÇOS" + ' (' + rest.servicos.length +')'}
        //subheader={}
      />
      <Divider/>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          
          {rest.servicos.map((servico, index) => (
            <span key={index}>
              <CardHeader
        //      className={classes.avatar}
              //titleTypographyProps={{ className: classes.title }}
      
              avatar={
                  <Avatar aria-label="recipe" className={classes.avatar}>
                    {getAvatar(servico.inout)}
                  </Avatar>
          }
                title={servico.descservico}
                subheader={'Data:' + servico.dataservico} 
            />
              {(servico.inout != 0 && servico.inout != undefined )? (
                <CardHeader
                  avatar={
                < Avatar aria-label="recipe" className={getClassNameAvatar(servico.inout)}>
                    {getAvatarChegadaPartida(servico.inout)}
                </Avatar>
                
              }
              title={'Voo: ' + servico.descvoo}
              subheader={'Aeroporto: ' + servico.descorigemdestino + ' - Hs:' + servico.horainservico + 'h'} 

              />
            ) : null} 
            <CardHeader
                title={'Se apresentar às ' + servico.horaapresentacao + 'h'}
                //subheader={'Hora Início:' + servico.horainservico} 
                // pedido Conexão Receptivo não exibir - avaliar frente se necessário criar configuração;
            />
            
            <Divider/>
            </span>
          ))}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
       
        </IconButton>
        <IconButton aria-label="share">
        </IconButton>
        {/*<IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
        */}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Method:</Typography>
          <Typography paragraph>
            Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10
            minutes.
          </Typography>
          <Typography paragraph>
            Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
            heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
            browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
            and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
            pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
            saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
          </Typography>
          <Typography paragraph>
            Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
            without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
            medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
            again without stirring, until mussels have opened and rice is just tender, 5 to 7
            minutes more. (Discard any mussels that don’t open.)
          </Typography>
          <Typography>
            Set aside off of the heat to let rest for 10 minutes, and then serve.
          </Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
}

CardServicos.propTypes = {
//  className: PropTypes.string,
  //passageiros : propTypes.classes
};

export default CardServicos;
